"use client";

import { ScanSearchIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/*
 * The one way into a trace, wherever the app can show where something came from: a session (its latest answer's), a
 * channel's dashboard or data set view, a widget, a data set in Knowledge. The same outlined button, mark and word,
 * "Trace", in each, smaller on a tile; what is traced is said to assistive technology and under the pointer. Under an
 * answer, among its other actions, the same mark and word are a link like theirs.
 * It keeps its own presses: on a tile, whose header is a drag surface, or in a row that opens on a click.
 */

/** The trace's mark. */
export const TraceIcon = ScanSearchIcon;

export function TraceButton({ subject, onClick, size = "sm", className, labelClassName }: {
  /** What is traced, as the button's accessible name says it: "this dashboard's data". */
  subject: string;
  onClick?: () => void;
  /** Smaller on a tile than in a toolbar. */
  size?: "sm" | "xs";
  className?: string;
  /** Where a narrow toolbar hides words, the class that does. */
  labelClassName?: string;
}) {
  const label = `Trace ${subject}`;
  return (
    <Button type="button" variant="outline" size={size} className={cn("shrink-0", className)} aria-label={label} title={label}
      onPointerDown={(event) => event.stopPropagation()}
      onClick={(event) => { event.stopPropagation(); onClick?.(); }}>
      <TraceIcon data-icon="inline-start" />
      <span className={labelClassName}>Trace</span>
    </Button>
  );
}
